import React, { Component, ReactNode } from 'react';

import { connect } from 'react-redux';
import cx from 'classnames';
import { Button, InputNumber } from 'antd';

import { addTimeToCurrentTerm } from '../../../../slices/accounts/video/management/thunk';
import { FetchingStatus } from '../../../../slices/accounts/video/management/interfaces';
import { RootState } from '../../../../slices/rootReducer';
import { selectAddMinutesRequestStatus } from '../../../../slices/accounts/video/management/selectors';
import { TypeDispatchFunction } from '../../../../tsHelpers';

import styles from './addMinutesToCurrentTerm.module.scss';

interface IExternalProps {
  accountId: string;
  onCancel: () => void;
  onSucceeded?: () => void;
}

interface IState {
  minutes: number | undefined;
}

interface IMapStateToProps {
  addMinutesRequestStatus: FetchingStatus;
}

interface IMapDispatchToProps {
  addTimeToCurrentTerm: TypeDispatchFunction<typeof addTimeToCurrentTerm>;
}

type IProps = IExternalProps & IMapDispatchToProps & IMapStateToProps;

class AddMinutesToCurrentTermBase extends Component<IProps, IState> {
  constructor(props:IProps) {
    super(props);

    this.state = {
      minutes: undefined
    };

    this.handleAccept = this.handleAccept.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onMinutesChanged = this.onMinutesChanged.bind(this);
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if(prevProps.addMinutesRequestStatus === FetchingStatus.Loading && this.props.addMinutesRequestStatus === FetchingStatus.Succeeded) {
      this.handleOnSucceed();
    }
  }

  private handleAccept() {
    const { minutes } = this.state;

    if(minutes === undefined) {
      return;
    }

    this.props.addTimeToCurrentTerm({
      allocatedSeconds: minutes * 60,
      accountId: this.props.accountId
    });
  }

  private handleCancel() {
    this.props.onCancel();
  }

  private handleOnSucceed() {
    this.props.onSucceeded?.();
  }

  private onMinutesChanged(value: number | string | undefined) {
    const minutes = Number(value);
    if(isNaN(minutes)) {
      return;
    }
    this.setState({ minutes });
  }

  private renderAcceptCTA() {
    return (
      <div className={cx(styles.cta, styles.acceptWrapper)}>
        <Button loading={this.props.addMinutesRequestStatus === FetchingStatus.Loading} className={styles.noRoundLeft} onClick={this.handleAccept} type='primary'>Add minutes</Button>
      </div>
    );
  }

  private renderCancelCTA() {
    return (
      <div className={cx(styles.cta, styles.cancelWrapper)}>
        <Button onClick={this.handleCancel} className={styles.btn} type='link'>Cancel</Button>
      </div>
    );
  }

  private renderMinutesInput() {
    return (
      <div className={styles.inputWrapper}>
        <div className={styles.minutesWrapper}>
          <label >Minutes to add to current term</label>
          <InputNumber
            type="number"
            className={cx(styles.minutesInput, styles.noRoundRight)}
            id='minutes-input-oo'
            min={1}
            onChange={this.onMinutesChanged}
            value={this.state.minutes}
          />
        </div>
        {this.renderAcceptCTA()}
      </div>
    );
  }

  render(): ReactNode {
    return (
      <div className={styles.main}>
        {this.renderMinutesInput()}
        {this.renderCancelCTA()}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    addMinutesRequestStatus: selectAddMinutesRequestStatus(state)
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  addTimeToCurrentTerm
};

const AddMinutesToCurrentTerm = connect(mapStateToProps, mapDispatchToProps)(AddMinutesToCurrentTermBase);

export { AddMinutesToCurrentTerm };
